import { memone } from '@deqo/foundation';
import { injectable } from 'inversify';
import { debounce } from '../../../CodesThatsGottaGoSomewhereElse';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { AdapterInfo } from '../AdapterInfo';
import { EditorSession } from '../EditorSession';
import { Selection } from '../Selection';
import { ToolInfo } from '../tooling/ToolInfo';
import { WidgetManager } from '../workspace/widgets/WidgetManager';
import { PropertyHistory } from './PropertyHistory';
import { SizeWidget } from './SizeWidget';

const isToolStateBanned = (state: string) =>
    state !== 'idle' &&
    state !== 'panning' &&
    state !== 'selecting' &&
    state !== 'transforming' &&
    !state.endsWith('Primed');

@injectable()
export class SizeWidgetMechanics extends ActiveObject {

    @resolve(CommandDispatcher) dispatch!: CommandDispatcher;
    @resolve(EditorSession) session!: EditorSession;
    @resolve(ObjectManager) objects!: ObjectManager;
    @resolve(PropertyHistory) propHistory!: PropertyHistory;
    @resolve(WidgetManager) widgets!: WidgetManager;

    public start(): void {
        const syncDebounced = debounce(this.sync);
        this.burden(this.session.observe(AdapterInfo, syncDebounced));
        this.burden(this.session.observe(Selection, syncDebounced));
        this.burden(this.session.observe(ToolInfo, syncDebounced));
        // this.burden(new SelectionWatch(this.session, this.objects, syncDebounced));
    }

    private sync = () => {
        const [active, instanceId] = this.computeNextWidgetState();
        this.realizeWidget(active, instanceId);
    };

    private computeNextWidgetState(): [true, string] | [false] {
        const adapter = this.session.get(AdapterInfo);
        const selection = this.session.get(Selection);
        const tool = this.session.get(ToolInfo);
        if (selection.size !== 1) return [false];
        if (selection.locked()) return [false];
        if (adapter.target !== 'none') return [false];
        if (isToolStateBanned(tool.state)) return [false];
        return [true, selection.id];
    }

    @memone() // This acts as a call guard (only run if the args change)
    private realizeWidget(active?: boolean, instanceId?: string) {

        const existing = this.widgets.get('size');
        if (active && existing?.tag === instanceId) return;

        this.widgets.delete('size');
        if (!active) return;

        const targets = this.session.get(Selection).toArray();

        const dock = this.widgets.createContainer({
            name: 'size',
            position: ['attached', { to: targets.map(x => x.id), placement: 'bottom', offset: [.625, 0] }],
            style: 'none',

        });

        dock.add(this.widgets.createInline({
            ui: SizeWidget,
        }));

        this.widgets.add(dock);
    }
}


